import { render, staticRenderFns } from "./fattureDaPagare.vue?vue&type=template&id=a6defde4&"
import script from "./fattureDaPagare.vue?vue&type=script&lang=js&"
export * from "./fattureDaPagare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports